import React from "react";
import { NavLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import HugLogoSrc from "components/Logo/Logo.png";

const Footer = () => {
  return (
    <footer>
      <Box>
        <Box display="flex" justifyContent="center" mb={2} mt={8}>
          <img src={HugLogoSrc} height={30} alt="HiddenUnderGround logo" />
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          flexWrap="wrap"
          my={4}
        >
          {[
            { label: "Home", path: "/" },
            { label: "Help", path: "/help" },
            { label: "Feedback", path: "/feedback" },
            { label: "Privacy", path: "/privacy" },
            { label: "Terms", path: "/terms" },
            { label: "About", path: "/about" },
          ].map((link) => (
            <Typography
              key={link.path}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                margin: "0 20px",
                "& a": {
                  color: "#444",
                  textDecoration: "none",
                },
              }}
            >
              <NavLink to={link.path}>{link.label}</NavLink>
            </Typography>
          ))}
        </Box>
        <Box textAlign="center" my={2}>
          <Typography variant="caption" sx={{ fontSize: 14 }}>
            {new Date().getFullYear()} HiddenUnderGround
            <span
              style={{
                fontSize: "1.1em", // bigger
                verticalAlign: "super", // superscript
                marginLeft: "3px", // small space from text
              }}
            >
              ®
            </span>
            All rights reserved
          </Typography>
        </Box>
      </Box>
    </footer>
  );
};

export default Footer;
